import { API_ENDPOINTS } from './Constants';
import { apiFetch } from './apiHelper';
import { encryptPassword } from './cryptoHelper';

const PasswordChangeService = {
    requestReset: async (email) => {
        const response = await apiFetch(API_ENDPOINTS.PASSWORD_CHANGE_REQUEST, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || "Greška kod slanja zahtjeva");
        }
        return { ok: true, message: data.message };
    },

    resetPassword: async (email, code, newPassword) => {
        const encryptedPassword = await encryptPassword(newPassword);
        const response = await apiFetch(API_ENDPOINTS.PASSWORD_RESET, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, code, newPassword: encryptedPassword }),
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || "Greška kod resetiranja lozinke");
        }
        return data;
    }
};

export default PasswordChangeService;
